// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__198C1","comment":"styles_comment__2rhzF"};